export default function FacilityReuse() {
  const facilities = [
    {
      icon: 'ri-building-2-line',
      title: '校舎',
      description: '教室を養殖管理室、研究室、事務所として活用',
      features: ['水質管理センター', '研究開発室', '管理事務所']
    },
    {
      icon: 'ri-basketball-line',
      title: '体育館',
      description: '広い空間を養殖水槽エリアとして転用',
      features: ['大型養殖水槽', '循環システム', '作業スペース']
    },
    {
      icon: 'ri-home-smile-line',
      title: '寮・宿舎',
      description: '従業員の住居として提供し、移住を支援',
      features: ['従業員住宅', '共用スペース', '生活サポート']
    },
    {
      icon: 'ri-plant-line',
      title: '校庭・敷地',
      description: '太陽光発電や緑地として環境配慮型施設に',
      features: ['再生可能エネルギー', '緑地保全', '駐車場']
    }
  ];

  return (
    <section className="py-24 px-6 bg-gradient-to-b from-white to-[#F5F9F6]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-white border border-[#C8E6C9] mb-6">
            <i className="ri-recycle-line text-[#2D7A3E] text-lg mr-2"></i>
            <span className="text-[#2D7A3E] text-sm font-semibold whitespace-nowrap">施設の有効活用</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#1A2332] mb-6">
            既存施設を最大限に活用
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            廃校となった学校施設の特性を活かし、養殖産業に最適な環境へと転換。<br />
            建物の構造や設備を有効活用することで、初期投資を抑えながら持続可能な事業を実現します。
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-16">
          {facilities.map((facility, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-[#E8F5E9] text-center"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-[#2D7A3E] to-[#4CAF50] rounded-xl flex items-center justify-center mb-6 mx-auto">
                <i className={`${facility.icon} text-white text-3xl`}></i>
              </div>
              <h3 className="text-2xl font-bold text-[#1A2332] mb-3">{facility.title}</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">{facility.description}</p>
              <div className="space-y-2 inline-flex flex-col items-start">
                {facility.features.map((feature, idx) => (
                  <div key={idx} className="flex items-center">
                    <div className="w-1.5 h-1.5 bg-[#2D7A3E] rounded-full mr-3"></div>
                    <span className="text-sm text-gray-700">{feature}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="bg-white p-10 rounded-2xl shadow-xl border border-[#E8F5E9]">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-3xl font-bold text-[#1A2332] mb-6">
                なぜ廃校なのか
              </h3>
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-[#2D7A3E] rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-map-pin-line text-white text-lg"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-[#1A2332] mb-2">地域課題の解決</h4>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      全国で年間約500校が廃校となり、その多くが活用されていません。この地域資源を産業拠点として再生することで、地域の課題解決に貢献します。
                    </p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-[#2D7A3E] rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-funds-line text-white text-lg"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-[#1A2332] mb-2">初期投資の削減</h4>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      既存の建物や設備を活用することで、新規建設と比較して初期投資を大幅に削減。持続可能な事業運営を可能にします。
                    </p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-[#2D7A3E] rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-community-line text-white text-lg"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-[#1A2332] mb-2">地域との共生</h4>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      地域の思い出が詰まった学校を新しい形で活用することで、地域住民の理解と協力を得やすく、地域と共に成長できます。
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://storage.readdy-site.link/project_files/fc18929a-f6b4-4a9e-92ee-da32c9ea052d/514283ca-1927-48b6-8440-0e520c1eaff2_2580CCF575FD7BA94D0114D5CFB9387C987923A1.jpg?v=4d00d3085751d4d71a5abf1de7db841c"
                alt="廃校となった学校施設"
                className="w-full h-[450px] object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}